import React from "react";
import { useNavigate } from "react-router-dom";
import slugify from "../../utils/slugify";
import { useTheme } from "../../context/ThemeContext";
import { getThemeClasses } from "../utils/themeClass";

const GameCard = ({ game, index }) => {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const themeClass = getThemeClasses(theme);

  const handleGameCardClick = () => {
    const path = game.slug || slugify(game.title);
    navigate(`/game/${path}`, { state: { game } });
  };

  const imgSrc = game.thumb;

  return (
    <div
      onClick={handleGameCardClick}
      className={`
        relative w-24 sm:w-28 md:w-32 h-24 sm:h-28 md:h-32 flex-shrink-0
        cursor-pointer overflow-hidden rounded-2xl border
        shadow transition-transform duration-300 ease-in-out
        hover:scale-105 hover:shadow-lg
        ${themeClass.borderColor} ${themeClass.hoverBorder}
        group
      `}
    >
      {/* Game Thumbnail */}
      <img
        src={imgSrc}
        srcSet={`${imgSrc} 1x, ${imgSrc} 2x`}
        alt={game.slug}
        loading={index === 0 ? "eager" : "lazy"}
        fetchpriority={index === 0 ? "high" : undefined}
        className="absolute top-0 left-0 w-full h-full object-cover z-0 transition-opacity duration-300 group-hover:opacity-85 rounded-2xl"
      />

      {/* Subtle gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent z-[1] pointer-events-none rounded-2xl"></div>

      {/* Title Overlay */}
      <div
        className={`absolute bottom-0 w-full px-2 py-1 z-10 backdrop-blur-sm bg-black/30 group-hover:bg-black/50 transition-colors duration-300 rounded-b-2xl`}
      >
        <h3
          className={`text-[10px] sm:text-xs font-semibold text-center truncate text-white`}
        >
          {game.title}
        </h3>
      </div>
    </div>
  );
};

export default GameCard;
